import { Card } from "@/src/components";
import { useMetrics } from "@/src/hooks/useMetrics";
import { fmt } from "@/src/lib/utils";

export const Metrics = () => {
  const { supply, liquidity, liquidity2,  staked, burned, minted } = useMetrics();
  return (
    <div className="col-span-12 lg:col-span-8">
    <Card className="lg:min-h-[calc(100vh-130px)] h-full">
      <div className="max-w-2xl mx-auto w-full space-y-6">
        <h2 className="text-sm font-medium text-muted-foreground uppercase tracking-wider text-center">
          Overall FRB Metrics
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
          <div className="bg-secondary/30 rounded-xl p-3 sm:p-5 text-center space-y-1">
            <p className="text-sm text-muted-foreground">Supply</p>
            <p className="text-xl sm:text-2xl font-bold text-foreground font-mono">{fmt(supply/1000000)}M</p>
          </div>

          <div className="bg-secondary/30 rounded-xl p-3 sm:p-5 text-center space-y-1">
            <p className="text-sm text-muted-foreground">Burned</p>
            <p className="text-xl sm:text-2xl font-bold text-foreground font-mono">{fmt(burned/1000000)}M</p>
          </div>

          <div className="col-span-1 sm:col-span-2 bg-secondary/30 rounded-xl p-3 sm:p-5 text-center space-y-1">
            <p className="text-sm text-muted-foreground">Inflation</p>
            <p className="text-xl sm:text-2xl font-bold text-foreground font-mono">
              {fmt((supply-minted-burned)/parseInt(supply)*100)}% <span className="text-base text-muted-foreground font-normal font-sans">({fmt((supply-minted-burned-(staked*0.025))/parseInt(supply)*100)}% if unstaked)</span>
            </p>
          </div>

          <div className="col-span-1 sm:col-span-2 bg-secondary/30 rounded-xl p-3 sm:p-5 text-center space-y-1">
            <p className="text-sm text-muted-foreground">Harvested</p>
            <p className="text-xl sm:text-2xl font-bold text-foreground font-mono">{fmt((supply-minted)/1000000)}M</p>
          </div>
        </div>

        <h2 className="text-sm font-medium text-muted-foreground uppercase tracking-wider text-center pt-4">
          FRB Distribution
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
          <div className="bg-secondary/30 rounded-xl p-3 sm:p-5 text-center space-y-1">
            <p className="text-sm text-muted-foreground">Staked</p>
            <p className="text-xl sm:text-2xl font-bold text-primary font-mono">{fmt((parseInt(staked)/parseInt(supply))*100, 0)}%</p>
          </div>

          <div className="bg-secondary/30 rounded-xl p-3 sm:p-5 text-center space-y-1">
            <p className="text-sm text-muted-foreground">Liquidity Pool</p>
            <p className="text-xl sm:text-2xl font-bold text-primary font-mono">{fmt(((parseInt(liquidity)+parseInt(liquidity2))/parseInt(supply))*100, 0)}%</p>
          </div>
        </div>
      </div>
    </Card>
  </div>

  );
};
